import { NavLink } from "react-router-dom";
import styled from "styled-components";
import Icon from "../atoms/Icon";

export const Wrapper = styled.div``;

export const Container = styled.div`
  margin: 60px auto;
  display: flex;
  align-items: center;
  justify-content: center;

  width: 85%;
  position: relative;
  padding: 80px 50px;
  border-left: 1px solid #d2d1d173;
  border-bottom: 1px solid #d2d1d173;

  @media (max-width: 768px) {
    width: 90%;
  }
`;

export const ContentBox = styled.div`
  text-align: center;

  @media (min-width: 768px) {
    width: 60%;
  }
`;

export const Heading = styled.h2`
  font-size: clamp(1rem, 0.5455rem + 2.2727vw, 2.25rem);
  margin: 10px 0;
`;
export const Text = styled.p`
  font-size: 0.875rem;
  font-weight: 400;
  margin: 30px 0;
  line-height: 30px;
`;

export const CTAButton = styled.button.attrs({ as: NavLink })`
  color: white;
  padding: 16px;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  background: #ff1788;

  text-transform: capitalize;
  transition: background-color 0.3s ease-in-out;
  font-size: clamp(0.75rem, 0.6591rem + 0.4545vw, 1rem);

  &:hover {
    background-color: #ca136c;
  }
`;

export const ClockIcon = styled(Icon)`
  left: 0;
  top: 0;
  position: absolute;
  transform: translate(-50%, -50%);

  @media (max-width: 768px) {
    width: 30px;
    height: 30px;
  }
`;
export const CheckmarkIcon = styled(Icon)`
  top: 0;
  position: absolute;
  transform: translate(50%, -50%);

  @media (min-width: 768px) {
    width: 30px;
    height: 30px;
  }
`;
export const ClipboardIcon = styled(Icon)`
  right: 0;
  bottom: 0;
  position: absolute;
  transform: translate(50%, 50%);

  @media (min-width: 768px) {
    width: 30px;
    height: 30px;
  }
`;

export const Image = styled.img`
  width: 100%;
`;
